import { createSlice, PayloadAction, createAsyncThunk  } from '@reduxjs/toolkit'
import { Schedule } from '../ScheduleNotifications/scheduleNotificationsSlice'
import { activateScheduleEmail, deactivateScheduleEmail, deleteScheduleEmails, getScheduleEmail, getScheduleEmails, updateScheduleEmail, UpdateScheduleEmailBody } from '../../../../utils/requestsUtils/functionsRequests/emails/emailsFunctions'

export type DeviceEmailId = "All" | "Just_Desktop" | "Just_App"
export type DeviceEmail = {
    id:     DeviceEmailId
    text:   string
}

type TopicEmailId = "general-topic" | "gim-topic" | "gimmer-topic"
export type TopicEmail = {
    id:         TopicEmailId
    text:       string
    className:  string
}

export type FrecuencyEmailId = "One_time" | "Every_day" | "Every_week" | "Every_month"
export type FrecuencyEmail = {
    id:         FrecuencyEmailId
    text:       string
}

export type ScheduleEmail = {
    id:                       string
    bodyEmail:                string
    topic:                    string
    subject:                     string
    roleArnSchedule:          string
    scheduleCronExpression:   string
    schedule:                 Schedule
    userId:                   string
    activated:                number 
    frecuency:                FrecuencyEmailId
    device:                   DeviceEmailId
    creationDate:             string    
    counter:                  number
}




export const GetScheduleEmailsThunk = createAsyncThunk(
    'scheduleEmailsData/GetScheduleEmailsThunk',
    async (activated: number) => {
        try { 

            const data = await getScheduleEmails(activated)
            
            return {
                items: data.results,
                countActivated: data.countActivated,
                countDeactivated: data.countDeactivated,
                activated
            }
        } catch (error) {
            console.log("error", error)
            return {
              items: [] as ScheduleEmail[],
                countActivated: 0,
                countDeactivated: 0,
                activated
            }
        }
    }
)

export const GetScheduleEmailThunk = createAsyncThunk(
    'scheduleEmailsData/GetScheduleEmailThunk',
    async (id: string) => {
        try { 

            const item = await getScheduleEmail(id)
            return {
              item
            }
        } catch (error) {
            console.log("error", error)
            return {
              item: undefined
            }
        }
    }
)

export const DeleteScheduleEmailsThunk = createAsyncThunk(
    'scheduleEmailsData/DeleteScheduleEmailsThunk',
    async (id: string) => {
        try { 

            await deleteScheduleEmails(id)
            
            return { id }
        } catch (error) {
            console.log("error", error)
            alert("Error")
            return { id }
        }
    }
)

export const UpdateScheduleEmailsThunk = createAsyncThunk(
    'scheduleEmailsData/UpdateScheduleEmailsThunk',
    async ({ id, body }: { id: string, body: UpdateScheduleEmailBody }) => {
        try { 

            await updateScheduleEmail(id, body)
            
            return { id, body }
        } catch (error) {
            console.log("error", error)
            alert("Error")
            return { id, body }
        }
    }
)

export const ActivateScheduleEmailsThunk = createAsyncThunk(
    'scheduleEmailsData/ActivateScheduleEmailsThunk',
    async (id: string) => {
        try { 

            await activateScheduleEmail(id)
            
            return { id }
        } catch (error) {
            console.log("error", error)
            alert("Error")
            return { id }
        }
    }
)


export const DeactivateScheduleEmailsThunk = createAsyncThunk(
    'scheduleEmailsData/DeactivateScheduleEmailsThunk',
    async (id: string) => {
        try { 

            await deactivateScheduleEmail(id)
            
            return { id }
        } catch (error) {
            console.log("error", error)
            alert("Error")
            return { id }
        }
    }
)


type InitialState = {
    items: ScheduleEmail[]
    scheduleEmail?: ScheduleEmail
    loadingContainer: boolean
    loadingInitalData: boolean
    orderDirection: boolean
    orderColumn: string
    activated:  number
    countActivated: number
    countDeactivated: number
}

const initialState: InitialState = {
    items: [] as ScheduleEmail[],
    loadingInitalData: false,
    scheduleEmail: undefined,
    //LastEvaluatedKey: "",
    loadingContainer: false,
    orderDirection: false,
    orderColumn: "",
    activated: 1,
    countActivated: 0,
    countDeactivated: 0
}

export const scheduleEmailsDataSlice = createSlice({
  name: 'scheduleEmailsData',
  initialState,
  reducers: {
        setAddScheduleEmailReducer: (state, action: PayloadAction<ScheduleEmail>) => {
            /*
            state.modalName = "DeleteContractModal"

            const contractInfo = state.contracts.find((c) => c.countryName === action.payload.countryName)
            if(contractInfo)
                state.DeleteContractModalState = contractInfo
            */
            return state;
        },
        setUpdatedScheduleEmailReducer: (state, action: PayloadAction<{ id: string, body: UpdateScheduleEmailBody }>) => {
            const { id, body } = action.payload

            if(state.scheduleEmail){
                state.scheduleEmail = {
                    ...state.scheduleEmail,
                    ...body,
                    activated: 1
                }
            }

            state.items = state.items.map((item) => {
                if(item.id === id){
                    return {
                        ...item,
                        ...body,
                        activated: 1
                    }
                }
                return item
            })
            return state;
        },

        resetScheduleEmailItemReducer: (state) => {
            return {
                ...state,
                scheduleEmail: undefined
            }
        },
        resetScheduleEmailsReducer: () => {
            return initialState
        }
  },

  extraReducers: (builder) => {
    builder.addCase(GetScheduleEmailsThunk.fulfilled, (state, action: PayloadAction<{ items: ScheduleEmail[], activated: number, countActivated: number, countDeactivated: number}>) => {
        const { items, activated, countActivated, countDeactivated } = action.payload  
            state.activated = activated
            state.countActivated = countActivated
            state.countDeactivated = countDeactivated
            state.items = items
            state.loadingContainer = false
            return state
        }).addCase(GetScheduleEmailsThunk.pending, (state, action: any) => {
            state.loadingContainer = true
            return state     
        }).addCase(GetScheduleEmailsThunk.rejected, (state, action: any) => {
            const failState = {...initialState}
            failState.loadingContainer = false
            return failState
        })

        .addCase(GetScheduleEmailThunk.fulfilled, (state, action: PayloadAction<{ item: ScheduleEmail | undefined }>) => {
        const { item } = action.payload  
            state.scheduleEmail = item
            state.loadingInitalData = false
            return state
        }).addCase(GetScheduleEmailThunk.pending, (state, action: any) => {
            state.loadingInitalData = true
            return state     
        }).addCase(GetScheduleEmailThunk.rejected, (state, action: any) => {
            const failState = {...initialState}
            failState.loadingInitalData = false
            return failState
        })

        .addCase(DeleteScheduleEmailsThunk.fulfilled, (state, action: PayloadAction<{ id: string }>) => {

            const id = action.payload.id        
            state.items = state.items.filter((item) => item.id !== id)

            state.loadingContainer = false
            return state
        }).addCase(DeleteScheduleEmailsThunk.pending, (state, action: any) => {
            state.loadingContainer = true
            return state     
        }).addCase(DeleteScheduleEmailsThunk.rejected, (state, action: any) => {
            const failState = {...initialState}
            failState.loadingContainer = false
            return failState
        })

        .addCase(UpdateScheduleEmailsThunk.fulfilled, (state, action: PayloadAction<{ id: string, body: UpdateScheduleEmailBody }>) => {

                
            const { id, body } = action.payload

            if(state.scheduleEmail){
                state.scheduleEmail = {
                    ...state.scheduleEmail,
                    ...body,
                    activated: 1
                }
            }

            state.items = state.items.map((item) => {
                if(item.id === id){
                    return {
                        ...item,
                        ...body,
                        activated: 1
                    }
                }
                return item
            })
            

            state.loadingContainer = false
            return state
        }).addCase(UpdateScheduleEmailsThunk.pending, (state, action: any) => {
            state.loadingContainer = true
            return state     
        }).addCase(UpdateScheduleEmailsThunk.rejected, (state, action: any) => {
            const failState = {...initialState}
            failState.loadingContainer = false
            return failState
        })

      .addCase(ActivateScheduleEmailsThunk.fulfilled, (state, action: PayloadAction<{ id: string }>) => {

            const { id } = action.payload

            if(state.scheduleEmail){
                state.scheduleEmail = {
                    ...state.scheduleEmail,
                    activated: 1
                }
            }

            state.items = state.items.map((item) => {
                if(item.id === id){
                    return {
                        ...item,
                        activated: 1
                    }
                }
                return item
            })
            

            state.loadingContainer = false
            return state
        }).addCase(ActivateScheduleEmailsThunk.pending, (state, action: any) => {
            state.loadingContainer = true
            return state     
        }).addCase(ActivateScheduleEmailsThunk.rejected, (state, action: any) => {
            const failState = {...initialState}
            failState.loadingContainer = false
            return failState
        })

        .addCase(DeactivateScheduleEmailsThunk.fulfilled, (state, action: PayloadAction<{ id: string }>) => {

            const { id } = action.payload

            if(state.scheduleEmail){
                state.scheduleEmail = {
                    ...state.scheduleEmail,
                    activated: 0
                }
            }

            state.items = state.items.map((item) => {
                if(item.id === id){
                    return {
                        ...item,
                        activated: 0
                    }
                }
                return item
            })

            state.loadingContainer = false
            return state
        }).addCase(DeactivateScheduleEmailsThunk.pending, (state, action: any) => {
            state.loadingContainer = true
            return state     
        }).addCase(DeactivateScheduleEmailsThunk.rejected, (state, action: any) => {
            const failState = {...initialState}
            failState.loadingContainer = false
            return failState
        })
      
  },

});

export const {  
    resetScheduleEmailsReducer,
    setAddScheduleEmailReducer,
    resetScheduleEmailItemReducer,
    setUpdatedScheduleEmailReducer
} = scheduleEmailsDataSlice.actions

export default scheduleEmailsDataSlice.reducer